import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { storyClosingCta } from '@/content/my-story';

export function StoryClosingCta() {
  return (
    <section
      aria-labelledby="story-cta-heading"
      className="px-4 py-16 sm:px-6 sm:py-20 lg:px-8"
    >
      <div className="border-border/70 bg-card/55 mx-auto w-full max-w-3xl rounded-2xl border px-6 py-12 shadow-sm sm:px-10 sm:py-14">
        <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">
          {storyClosingCta.eyebrow}
        </p>
        <h2
          id="story-cta-heading"
          className="font-display text-foreground text-2xl font-semibold tracking-tight text-balance sm:text-3xl"
        >
          {storyClosingCta.heading}
        </h2>
        <p className="text-muted-foreground mt-4 text-base leading-relaxed sm:text-lg">
          {storyClosingCta.body}
        </p>

        <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center">
          <Button asChild size="lg" variant="cta" className="sm:min-w-48">
            <Link to={storyClosingCta.primary.href}>{storyClosingCta.primary.label}</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="sm:min-w-48">
            <Link to={storyClosingCta.secondary.href}>{storyClosingCta.secondary.label}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
